import { render } from "./ResolveDisputeModal.vue?vue&type=template&id=2ee4ff76&scoped=true"
import script from "./ResolveDisputeModal.vue?vue&type=script&lang=js"
export * from "./ResolveDisputeModal.vue?vue&type=script&lang=js"

import "./ResolveDisputeModal.vue?vue&type=style&index=0&id=2ee4ff76&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee4ff76"]])

export default __exports__